import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

export const CardTabWithHelp = (title, tooltip, tooltipPosition = "top") => {
   
    
    return (
      <span>
        {title}
        <OverlayTrigger
          placement={tooltipPosition}
          overlay={
            <Tooltip id={`tooltip-${title}`}>
              {tooltip}
            </Tooltip>
          }
        >
          <FontAwesomeIcon 
            icon={faQuestionCircle} 
            className="ms-2 text-muted"
            style={{ fontSize: '0.8rem', cursor: 'help' }}
          />
        </OverlayTrigger>
      </span>
    );
  };